import { IReducerFn } from '../type';
import { TReducerRefundableFare } from './refundableFare.type';

export const RefundableFareReducer: IReducerFn<TReducerRefundableFare> = (state, { type, payload }) => {
  switch (type) {
    case 'truckers_refundable_tarif_loading':
      return {
        ...state,
        isFetchingRefundableFare: true,
        isFetchedRefundableFare: false,
        errorRefundableFare: false,
        dataRefundableFare: [],
      };
    case 'truckers_refundable_tarif_loaded':
      return {
        ...state,
        isFetchingRefundableFare: false,
        isFetchedRefundableFare: true,
        errorRefundableFare: false,
      };
    case 'truckers_refundable_tarif':
      return {
        ...state,
        dataRefundableFare: payload,
      };
    case 'truckers_refundable_tarif_remove':
      return {
        ...state,
        dataRefundableFare: [],
      };
    case 'truckers_refundable_tarif_error':
      return {
        ...state,
        isFetchingRefundableFare: false,
        isFetchedRefundableFare: false,
        errorRefundableFare: true,
      };

    default:
      return state;
  }
};

RefundableFareReducer.key = 'refundableFare';
RefundableFareReducer.initialState = {
  isFetchingRefundableFare: false,
  isFetchedRefundableFare: false,
  dataRefundableFare: [],
  errorRefundableFare: false,
};
